<template>
  <!-- <v-dialog v-model="cancelDialog" max-width="70%" persistent> -->
  <v-card>
    <validation-observer ref="cancelDate" v-slot="{ invalid }">
      <v-card-title class="text-h6 text-center">
        <span class="blue-grey--text text--darken-3"
          >¿Desea cancelar esta consulta?</span
        >
      </v-card-title>
      <v-card-text>
        <v-row v-if="dataModal && dataModal.idPatient">
          <v-col cols="12" md="12" sm="12" align="left">
            <patient-information :model="dataModal" />
          </v-col>

          <v-col cols="12" md="12" sm="12">
            <Patient-consultation-info :model="dataModal" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            @click.right.prevent
            @copy.prevent
            @paste.prevent
            ondrop="return false;"
          >
            <v-form v-model="valid" lazy-validation>
              <validation-provider
                v-slot="{ errors }"
                name="Motivo"
                rules="required|min:6"
              >
                <v-textarea
                  outlined
                  v-model="reason"
                  :value="reason"
                  label="Motivo de la cancelación"
                  id="cancellation"
                  :error-messages="errors"
                  required
                  rows="3"
                ></v-textarea>
              </validation-provider>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="text-center">
        <v-col class=" justify-space-around">
          <v-menu
            offset-x
            bottom
            left
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mr-12 mb-4"
                outlined
                color="error"
                v-bind="attrs"
                v-on="{ ...menu }"
                @click="confirmationReturn()"
              >
                <v-icon left> mdi-keyboard-backspace </v-icon>
                Regresar
              </v-btn>
            </template>
          </v-menu>
          <v-menu
            offset-x
            bottom
            rigth
            :close-on-content-click="true"
            rounded="lg"
          >
            <template v-slot:activator="{ on: menu, attrs }">
              <v-btn
                type="button"
                class="mb-4"
                :disabled="invalid"
                v-bind="attrs"
                v-on="{ ...menu }"
                color="primary"
                @click="confirmationCancel()"
              >
                Cancelar
                <v-icon right>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-card-actions>
    </validation-observer>
    <v-dialog v-model="swalDialog" persistent></v-dialog>
  </v-card>

  <!-- </v-dialog> -->
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { MedicalPracticeService } from "@/app/services";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import PatientConsultationInfo from "@/app/components/common/patient/PatientConsultationInfo.vue";
export default {
  name: "CancelationModal",
  props: {
    dataModal: {},
    dialogCancelation: Boolean,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    PatientInformation,
    PatientConsultationInfo,
  },
  data() {
    return {
      isLoading: false,
      cancelDialog: false,
      reason: "",
      valid: false,
      swalDialog: false,
      // isCancelation: true,
    };
  },
  created() {},
  mounted() {
    this.cancelDialog = this.dialogCancelation;
  },
  watch: {
    dialogCancelation: function() {
      this.cancelDialog = this.dialogCancelation;
    },
  },
  methods: {
    cancelConsultation() {
      if (!this.isLoading) {
        if (this.$refs.cancelDate.validate()) {
          this.isLoading = true;
          let params = {
            appointment: {
              idAppointment: this.dataModal.idAppointment,
            },
            reason: this.reason,
            medicalPractice: {
              idMedicalPractice: this.dataModal.idMedicalPractice,
              idHumanResource: this.$utilFront.getIdHumanResource(),
            },
          };
          MedicalPracticeService.cancelMedicalAppointment(params)
            .then((res) => {
              this.$utilFront.notifications(
                "Consulta cancelada correctamente",
                "SUCCESS"
              );
              this.closeCancel();
            })
            .catch((error) => {
              this.$utilFront.errorhttp(error);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      }
    },
    resetDialog() {},
    closeCancel() {
      this.reason = null;
      this.$refs.cancelDate.reset();
      let flag = false;
      this.$emit("closeCancelationDialog", flag);
      this.cancelDialog = flag;
    },
    confirmationReturn() {
      return this.closeCancel();
    },
    confirmationCancel() {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea eliminar la consulta actual?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          (this.swalDialog = false), this.cancelConsultation();
        } else {
          this.swalDialog = false;
        }
      });
    },
  },
};
</script>
